import { postRequest } from "./apiService";

const BASE_URL =
  "https://lexai-property-analysis-74624883720.us-central1.run.app";
const API_KEY = "2f8b7e2c-4c1a-4e2a-9b1a-123456789abc";

/**
 * Calls the analyze-property endpoint with the given application ID and address.
 * @param {Object} params
 * @param {string} params.applicationId - The application ID to analyze.
 * @param {string} params.address - The address to analyze.
 * @returns {Promise<any>} - The analysis result.
 */
export const analyzeProperty = async ({ applicationId, address }) => {
  const url = `${BASE_URL}/analyze-property?api_key=${API_KEY}`;

  const formData = new FormData();
  formData.append("application_id", applicationId);
  formData.append("address", address);

  const headers = {
    Accept: "application/json"
    // Do not set Content-Type — axios will set it correctly when using FormData
  };

  return postRequest(url, formData, headers);
};
